const intercom = {
  setUserHash: async function (): Promise<boolean> {
    return true
  },
  loginUserWithUserAttributes: async function (): Promise<boolean> {
    return true
  },
  logout: async function (): Promise<boolean> {
    return true
  },
  sendTokenToIntercom: async function (): Promise<boolean> {
    return true
  },
}

export default intercom
